<div class="card w-full p-4">
  <div class="flex items-center mb-4">
    <span class="font-semibold text-lg text-gray-700">Recherche par mot clé</span>
  </div>

  <!-- Bloc 1 : Au fournisseur + Checkbox Fonction support sur la même ligne -->
  <div class="mb-4" *ngIf="showSupplierSearch">
    <div class="flex flex-row items-center w-full gap-4">
      <!-- Au fournisseur -->
      <div class="flex flex-row items-center flex-1">
        <label for="supplier-search" class="block text-gray-700 text-sm font-bold mb-2 mr-4" style="min-width: 110px">
          Au fournisseur
        </label>
        <div class="w-full flex border border-gray-300 rounded overflow-hidden">
          <input
            type="text"
            id="supplier-search"
            name="supplier-search"
            placeholder="Mot clé..."
            class="p-2 w-full focus:outline-none"
            [formControl]="searchSupplier"
          />
        </div>
      </div>

      <!-- Checkbox Fonction support (conditionnelle, alignée à droite) -->
      <div *ngIf="authService.checkCurrentIsPredik()" class="flex flex-row items-center flex-1 justify-start">
        <mat-checkbox
          [formControl]="supportEstablishmentFilter"
          class="text-gray-700 text-sm font-bold whitespace-nowrap"
        >
          Fonction support
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Bloc 2 : Au générique + Au catalogue sur la même ligne (50/50) -->
  <div class="mb-4">
    <div class="flex flex-row items-center w-full gap-4">
      <!-- Au générique (50%) -->
      <div class="flex flex-row items-center flex-1">
        <label for="generic-search" class="block text-gray-700 text-sm font-bold mb-2 mr-4" style="min-width: 100px">
          Au générique
        </label>
        <div class="w-full flex border border-gray-300 text-gray-700 rounded overflow-hidden">
          <input
            type="text"
            id="generic-search"
            name="generic-search"
            placeholder="Mot clé..."
            [formControl]="genericControl"
            [matAutocomplete]="groupAuto"
            class="p-2 w-full focus:outline-none"
          />
          <!-- display button only if genericControl has value -->
          <button *ngIf="genericControl.value" (click)="clearSelection()" class="p-2 text-gray-500 focus:outline-none">
            &#x2715;
          </button>
        </div>
      </div>

      <!-- Au catalogue (50%) -->
      <div class="flex flex-row items-center flex-1">
        <label for="catalogue-search" class="block text-gray-700 text-sm font-bold mb-2 mr-4" style="min-width: 100px">
          Au catalogue
        </label>
        <div class="w-full flex border border-gray-300 rounded overflow-hidden">
          <input
            type="text"
            id="catalogue-search"
            name="catalogue-search"
            placeholder="Mot clé..."
            class="p-2 w-full focus:outline-none"
            [formControl]="searchLabel"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<mat-autocomplete
  #groupAuto="matAutocomplete"
  panelWidth="auto"
  [displayWith]="displayGeneric"
  (optionSelected)="emitSearchData()"
>
  <ng-container *ngFor="let group of generic$ | async">
    <mat-optgroup [label]="group.type">
      <mat-option *ngFor="let item of group.items" [value]="item">
        {{ item.label }}
      </mat-option>
    </mat-optgroup>
  </ng-container>
</mat-autocomplete>
